import { forwardRef, useMemo } from 'react';

import uuid from 'Lib/utils/uuid';

const idFormater = 'xxxxxxxxxxxxxxxx';

function createId() {
  return uuid(idFormater);
}

export type SvgIconProps = React.SVGProps<SVGSVGElement> & {
  desc?: string;
  title?: string;
};

const SvgIcon = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
  const { children, desc, title, ...restProps } = props;
  const titleId = useMemo(() => (title ? createId() : ''), [title]);
  const descId = useMemo(() => (desc ? createId() : ''), [desc]);
  const label = `${titleId} ${descId}`.trim();

  const svgProps: React.SVGProps<SVGSVGElement> = {
    ref,
    focusable: 'false',
    'aria-hidden': title ? 'false' : 'true',
    role: title ? 'img' : 'presentation',
    viewBox: '0 0 24 24',
    width: '24px',
    height: '24px',
    ...restProps,
  };

  if (label) {
    svgProps['aria-labelledby'] = label;
  }

  return (
    <svg {...svgProps} {...restProps}>
      {children}
      {title ? <title id={titleId}>{title}</title> : null}
      {desc ? <desc id={descId}>{desc}</desc> : null}
    </svg>
  );
});

export default SvgIcon;
